module.exports = __webpack_public_path__ + "img/icon-num6.69c2a021.png";